<template>
  <div>
    <Card>
      <Row class="operation">
        <Button @click="handleAdd" type="primary" icon="md-add">新增简章</Button>
        <Button @click="handleRefresh" icon="md-refresh">刷新</Button>
        <Input v-model="searchVal" placeholder="搜索标题" style="width: 200px" @on-enter="handleSearch" />
        <Button @click="handleSearch" type="ghost">搜索</Button>
      </Row>
      <br />
      <Table :loading="loading" border :columns="columns" :data="dataList" ref="table"></Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right">
          <Page :total="total" :current="page" :page-size="limit" show-total show-elevator @on-change="changePage"/>
        </div>
      </div>
    </Card>

    <Modal v-model="modalVisible" :title="modalTitle" width="700" @on-ok="handleSubmit" @on-cancel="handleCancel">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="标题" prop="title">
          <Input v-model="formValidate.title" placeholder="请输入简章标题" />
        </FormItem>
        <FormItem label="批次/期次" prop="batch">
          <Input v-model="formValidate.batch" placeholder="如：2026年第一批" />
        </FormItem>
        <FormItem label="分类" prop="category">
          <Select v-model="formValidate.category" style="width: 100%">
            <Option value="事业单位">事业单位</Option>
            <Option value="教师招聘">教师招聘</Option>
            <Option value="医疗卫生">医疗卫生</Option>
            <Option value="国企招聘">国企招聘</Option>
            <Option value="招聘">招聘</Option>
          </Select>
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio :label="0">草稿</Radio>
            <Radio :label="1">发布</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="报名开始">
          <DatePicker type="datetime" v-model="formValidate.start_time" format="yyyy-MM-dd HH:mm:ss" placeholder="报名开始时间" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="报名截止">
          <DatePicker type="datetime" v-model="formValidate.end_time" format="yyyy-MM-dd HH:mm:ss" placeholder="报名截止时间" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="准考证打印开始">
          <DatePicker type="datetime" v-model="formValidate.ticket_start" format="yyyy-MM-dd HH:mm:ss" placeholder="准考证打印开始" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="准考证打印截止">
          <DatePicker type="datetime" v-model="formValidate.ticket_end" format="yyyy-MM-dd HH:mm:ss" placeholder="准考证打印截止" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="考试时间">
          <DatePicker type="datetime" v-model="formValidate.exam_time" format="yyyy-MM-dd HH:mm:ss" placeholder="考试时间" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="考试地点">
          <Input v-model="formValidate.exam_address" placeholder="考试地点" />
        </FormItem>
        <FormItem label="备注">
          <Input v-model="formValidate.remark" type="textarea" :rows="2" placeholder="备注" />
        </FormItem>
        <FormItem label="招聘简章内容">
          <div class="editor-wrap">
            <textarea v-model="formValidate.content" class="textarea-html" rows="12" style="width:100%;min-height:200px;border:1px solid #dcdee2;border-radius:4px;padding:8px;resize:vertical" placeholder="请输入简章详细内容（支持HTML）"></textarea>
          </div>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { getJianzhangList, addJianzhang, updateJianzhang, deleteJianzhang } from '@/api/jianzhang.js'

export default {
  name: 'JianzhangList',
  data () {
    return {
      loading: false,
      dataList: [],
      total: 0,
      page: 1,
      limit: 10,
      searchVal: '',
      modalVisible: false,
      modalTitle: '',
      editMode: 'add',
      columns: [
        { type: 'selection', width: 55, align: 'center' },
        { title: 'ID', key: 'id', width: 70 },
        { title: '标题', key: 'title', minWidth: 200, ellipsis: true },
        { title: '分类', key: 'category', width: 100 },
        { title: '状态', key: 'statusText', width: 90, render: (h, params) => {
          return h('Tag', { props: { color: params.row.state === 1 ? 'success' : 'default' } }, params.row.state === 1 ? '已发布' : '草稿')
        } },
        { title: '报名时间', key: 'timeRange', minWidth: 240 },
        { title: '报名人数', key: 'apply_count', width: 90 },
        { title: '创建时间', key: 'create_time', width: 160 },
        { title: '操作', key: 'action', width: 240, align: 'center', render: (h, params) => {
          return h('div', [
            h('Button', { props: { type: 'primary', size: 'small' }, style: { marginRight: '5px' }, on: { click: () => this.handleApplies(params.row) } }, '报名记录'),
            h('Button', { props: { type: 'default', size: 'small' }, style: { marginRight: '5px' }, on: { click: () => this.handleEdit(params.row) } }, '编辑'),
            h('Button', { props: { type: 'error', size: 'small' }, on: { click: () => this.handleDelete(params.row) } }, '删除')
          ])
        } }
      ],
      formValidate: {
        id: null,
        title: '',
        batch: '',
        category: '招聘',
        status: 1,
        start_time: '',
        end_time: '',
        ticket_start: '',
        ticket_end: '',
        exam_time: '',
        exam_address: '',
        remark: '',
        content: ''
      },
      ruleValidate: {
        title: [{ required: true, message: '请输入简章标题', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init () {
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      getJianzhangList({ page: this.page, limit: this.limit, title: this.searchVal }).then(res => {
        this.loading = false
        if (res.data.code === 0) {
          const data = res.data.data
          this.dataList = (data.list || []).map(item => {
            item.timeRange = (item.start_time || '') + ' 至 ' + (item.end_time || '')
            return item
          })
          this.total = data.total || 0
        } else {
          this.$Message.error(res.data.msg || '获取失败')
        }
      }).catch(() => {
        this.loading = false
        this.$Message.error('请求失败')
      })
    },
    handleAdd () {
      this.editMode = 'add'
      this.modalTitle = '新增简章'
      this.formValidate = {
        id: null,
        title: '',
        batch: '',
        category: '招聘',
        status: 1,
        start_time: '',
        end_time: '',
        ticket_start: '',
        ticket_end: '',
        exam_time: '',
        exam_address: '',
        remark: '',
        content: ''
      }
      this.modalVisible = true
    },
    handleEdit (row) {
      this.editMode = 'edit'
      this.modalTitle = '编辑简章'
      this.formValidate = {
        id: row.id,
        title: row.title,
        batch: row.batch || '',
        category: row.category || '招聘',
        status: row.state === 1 ? 1 : 0,
        start_time: row.start_time || '',
        end_time: row.end_time || '',
        ticket_start: row.ticket_start || '',
        ticket_end: row.ticket_end || '',
        exam_time: row.exam_time || '',
        exam_address: row.exam_address || '',
        remark: row.remark || '',
        content: row.content || ''
      }
      this.modalVisible = true
    },
    handleSubmit () {
      const data = { ...this.formValidate }
      if (this.editMode === 'add') {
        addJianzhang(data).then(res => {
          if (res.data.code === 0) {
            this.$Message.success('新增成功')
            this.modalVisible = false
            this.fetchList()
          } else {
            this.$Message.error(res.data.msg || '新增失败')
          }
        })
      } else {
        updateJianzhang(data).then(res => {
          if (res.data.code === 0) {
            this.$Message.success('更新成功')
            this.modalVisible = false
            this.fetchList()
          } else {
            this.$Message.error(res.data.msg || '更新失败')
          }
        })
      }
    },
    handleCancel () {
      this.modalVisible = false
    },
    handleDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定删除简章「${row.title}」吗？`,
        onOk: () => {
          deleteJianzhang(row.id).then(res => {
            if (res.data.code === 0) {
              this.$Message.success('删除成功')
              this.fetchList()
            } else {
              this.$Message.error(res.data.msg || '删除失败')
            }
          })
        }
      })
    },
    handleApplies (row) {
      this.$router.push({ path: `/jianzhang/applies/${row.id}` })
    },
    handleSearch () {
      this.page = 1
      this.fetchList()
    },
    handleRefresh () {
      this.fetchList()
    },
    changePage (v) {
      this.page = v
      this.fetchList()
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
.operation {
  margin-bottom: 10px;
}
.operation .ivu-btn, .operation .ivu-input {
  margin-right: 8px;
}
</style>